import { cx } from '@linaria/core';
import type { KeyboardEvent } from 'react';

import CancelIcon from '~public/assets/icons/cancel.svg';
import SearchIcon from '~public/assets/icons/search.svg';
import {
	InputWithIcons,
	type Props,
} from '~shared/ui/molecules/InputWithIcons';

import { root, shrinkable } from './styles';

export interface SearchInputProps extends Props {
	width?: string;
	shrinkable?: boolean;
	onReset?: () => void;
}

const blurOnEnter = (event: KeyboardEvent<HTMLInputElement>) => {
	if (event.key === 'Enter') {
		event.currentTarget.blur();
	}
};

export const SearchInput = ({
	className,
	style,
	width,
	shrinkable: shrink = true,
	onReset,
	...props
}: SearchInputProps) => (
	<InputWithIcons
		className={cx(className, root, shrink && shrinkable)}
		style={{
			...style,
			...(width ? { '--width': width } : {}),
		}}
		placeholder="Search"
		leftIcon={<SearchIcon />}
		rightIcon={<CancelIcon width={24} height={24} />}
		onRightIconClick={onReset}
		onKeyDown={blurOnEnter}
		{...props}
	/>
);
